import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("home")) {
    gsap.registerPlugin(ScrollTrigger);

    const blobs = document.querySelectorAll(".hero-blob");
    if (blobs.length > 0) {
      gsap.from(blobs, {
        scale: 0.8,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        ease: "power2.out",
      });
    }

    const logoSliderElement = document.querySelector('.logo-slider');
    if (logoSliderElement) {
      const logoSwiper = new Swiper('.logo-slider', {
        modules: [Autoplay, Navigation],
        slidesPerView: 2,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }
      });

      const logoSlides = document.querySelectorAll('.logo-slide');
      logoSlides.forEach(slide => {
        const img = slide.querySelector('img');
        if (img) {
          slide.addEventListener('mouseenter', () => {
            img.style.transform = 'scale(1.1)';
          });
          
          slide.addEventListener('mouseleave', () => {
            img.style.transform = 'scale(1)';
          });
        }
      });
    }

    const testimonialSliderElement = document.querySelector('.testimonial-slider');
    if (testimonialSliderElement) {
      const testimonialSwiper = new Swiper('.testimonial-slider', {
        modules: [Autoplay],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
            }
        }
      });
    }
  }
});